// EditProfile.jsx


import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Grid, CircularProgress } from '@mui/material';
import EditProfileStyles from './EditProfile.styles';
import { useLocation } from 'react-router-dom';
import useUserProfile from '../../hooks/useUserProfile';

const EditProfile = () => {
  const location = useLocation();
  const userType = location.state?.userType || 'user';
  const { profileData, loading, updateProfile } = useUserProfile();
  const [formData, setFormData] = useState(profileData);

  // Sync form data with profile data
  useEffect(() => {
    setFormData(profileData);
  }, [profileData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Format phone number as user types (XXX-XXX-XXXX)
  const handlePhoneChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '');
    const limitedDigits = digits.slice(0, 10);
    let formatted = '';
    if (limitedDigits.length > 0) {
      formatted = limitedDigits.slice(0, 3);
    }
    if (limitedDigits.length > 3) {
      formatted += '-' + limitedDigits.slice(3, 6);
    }
    if (limitedDigits.length > 6) {
      formatted += '-' + limitedDigits.slice(6, 10);
    }
    setFormData({ ...formData, phone: formatted });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { fullName, email, phone } = formData;

    // Update Firestore with the new data
    await updateProfile({
      fullName,
      email,
      phone,
    });
    console.log('Profile updated successfully:', formData);
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', marginTop: '2rem' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={EditProfileStyles.container}>
      <Typography variant="h4" sx={EditProfileStyles.title}>
        Edit Profile
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Common fields */}
          <Grid item xs={12}>
            <TextField
              label="Full Name"
              fullWidth
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              sx={EditProfileStyles.textField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              fullWidth
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              sx={EditProfileStyles.textField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Phone Number"
              fullWidth
              name="phone"
              value={formData.phone || ''}
              onChange={handlePhoneChange}
              sx={EditProfileStyles.textField}
              placeholder="(555) 123-4567"
              helperText="Enter 10-digit phone number"
              inputProps={{ inputMode: "tel", maxLength: 12 }}
            />
          </Grid>

          {/* Agent-specific fields */}
          {userType === 'agent' && (
            <>
              <Grid item xs={12}>
                <TextField
                  label="Company Name"
                  fullWidth
                  name="companyName"
                  value={formData.companyName || ''}
                  onChange={handleInputChange}
                  sx={EditProfileStyles.textField}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="License Number"
                  fullWidth
                  name="licenseNumber"
                  value={formData.licenseNumber || ''}
                  onChange={handleInputChange}
                  sx={EditProfileStyles.textField}
                />
              </Grid>
            </>
          )}
        </Grid>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={EditProfileStyles.submitButton}
        >
          Save Changes
        </Button>
      </form>
    </Box>
  );
};

export default EditProfile;

